import React from 'react';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import Markdown from '@/pages/Dev/components/Markdown';
import { doBuried } from '@/services/buriedService';
// import { Link } from 'react-router-dom';

export default function Csharp({ brokerServiceUrl }) {
  const content1 = `
  使用以下命令安装指定版本DotPulsar包：  

  ~~~bash~DEV_CSHARP_NUGET_PACKAGE_1_COPY
  dotnet add package DotPulsar --version 3.3.1
  ~~~

  完成后打开.csproj 文件即可查看添加的引用：

  ~~~xml~DEV_CSHARP_NUGET_PACKAGE_2_COPY
  <ItemGroup>
    <PackageReference Include="DotPulsar" Version="3.3.1" />
  </ItemGroup>
  ~~~
  `;
  const content2 = `
  ~~~csharp~DEV_CSHARP_PRODUCER_COPY
  using DotPulsar;
  using DotPulsar.Extensions;
  using System;
  using System.Linq;
  using System.Text;
  using System.Threading;
  using System.Threading.Tasks;

  var token = "YOUR_PULSAR_TOKEN";
  var client = PulsarClient.Builder().ServiceUrl(new Uri("${brokerServiceUrl}"))
                  .Authentication(AuthenticationFactory.Token(token))
                  .RetryInterval(TimeSpan.FromSeconds(3))
                  .Build();
  var producer = client.NewProducer()
                      .Topic("topic-demo")
                      .Create();
  while (true)
  {
      var data = Encoding.UTF8.GetBytes("Hello World ! Message @"+ System.DateTime.Now.ToString());
      producer.Send(data);
      Thread.Sleep(1000);
  }
  ~~~
  `;
  const content3 = `
  ~~~csharp~DEV_CSHARP_CONSUMER_COPY
  using DotPulsar;
  using DotPulsar.Extensions;
  using System;

  var token = "YOUR_PULSAR_TOKEN";
  var client = PulsarClient.Builder().ServiceUrl(new Uri("${brokerServiceUrl}"))
                  .Authentication(AuthenticationFactory.Token(token))
                  .RetryInterval(TimeSpan.FromSeconds(3))
                  .Build();
  var consumer = client.NewConsumer()
                        .Topic("topic-demo")
                        .SubscriptionName("subscription-demo")
                        .Create();
  try
  {
      await foreach (var message in consumer.Messages())
      {
          Console.WriteLine($"Received: {message.Value()}");
          await consumer.Acknowledge(message);
      }
  }
  catch (Exception ex) 
  {
      Console.WriteLine(ex.Message);
  }
  ~~~
  `;

  const onChange = (val) => doBuried({ eventId: val });

  return (
    <Tabs defaultValue='DEV_CSHARP_NUGET_PACKAGE' onChange={onChange}>
      <TabPanel value='DEV_CSHARP_NUGET_PACKAGE' label='NuGet Package'>
        <Markdown content={content1} />
      </TabPanel>
      <TabPanel value='DEV_CSHARP_PRODUCER' label='Producer'>
        <Markdown content={content2} />
      </TabPanel>
      <TabPanel value='DEV_CSHARP_CONSUMER' label='Consumer'>
        <Markdown content={content3} />
      </TabPanel>
    </Tabs>
  );
}
